<app-toolbar>
  <app-breadcrumbs></app-breadcrumbs>
  <app-page-search class="me-auto" [(searchString)]="filter.Global" [(showFilters)]="filter.AdvancedFilter" (searchStringChange)="search$.next($event)"></app-page-search>
  <app-toolbar-list-buttons [showAdd]="PRIVILEGES.EditManufacturing | userHasPrivilege" (addClick)="goToAdd()" *transloco="let t; read: 'ime.components.action-bar'">
    <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="saveExcel()">
      <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#table-cells'">
      </svg>
      {{t('Export')}}
    </button>
  </app-toolbar-list-buttons>
</app-toolbar>
<app-resource-table [filter]="filter"
                    [search$]="search$" (onSelect)="open($event)"
                    (filterChanged)="runChangeDetector()"></app-resource-table>
